.FrogModal .DiceLayout {
  font-size: 0.5em;
}
.RollingModal,
.LootModal,
.LearnToRightClickModal,
.RollModal,
.FrogModal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(178, 167, 155, 0.8);
}
.RollingModal .Header,
.LootModal .Header,
.LearnToRightClickModal .Header,
.RollModal .Header,
.FrogModal .Header,
.RollingModal .Footer,
.LootModal .Footer,
.LearnToRightClickModal .Footer,
.RollModal .Footer,
.FrogModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-bottom: 0.4em;
}
.RollingModal .Header .BigText,
.LootModal .Header .BigText,
.LearnToRightClickModal .Header .BigText,
.RollModal .Header .BigText,
.FrogModal .Header .BigText,
.RollingModal .Footer .BigText,
.LootModal .Footer .BigText,
.LearnToRightClickModal .Footer .BigText,
.RollModal .Footer .BigText,
.FrogModal .Footer .BigText {
  font-size: 1.5em;
}
.RollingModal .Header .SmallText,
.LootModal .Header .SmallText,
.LearnToRightClickModal .Header .SmallText,
.RollModal .Header .SmallText,
.FrogModal .Header .SmallText,
.RollingModal .Footer .SmallText,
.LootModal .Footer .SmallText,
.LearnToRightClickModal .Footer .SmallText,
.RollModal .Footer .SmallText,
.FrogModal .Footer .SmallText {
  font-size: 0.75em;
}
.RollingModal .Header .SmallText[isHoverable]:hover,
.LootModal .Header .SmallText[isHoverable]:hover,
.LearnToRightClickModal .Header .SmallText[isHoverable]:hover,
.RollModal .Header .SmallText[isHoverable]:hover,
.FrogModal .Header .SmallText[isHoverable]:hover,
.RollingModal .Footer .SmallText[isHoverable]:hover,
.LootModal .Footer .SmallText[isHoverable]:hover,
.LearnToRightClickModal .Footer .SmallText[isHoverable]:hover,
.RollModal .Footer .SmallText[isHoverable]:hover,
.FrogModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.RollingModal.LearnToRightClickModal,
.LootModal.LearnToRightClickModal,
.LearnToRightClickModal.LearnToRightClickModal,
.RollModal.LearnToRightClickModal,
.FrogModal.LearnToRightClickModal,
.RollingModal.RollModal,
.LootModal.RollModal,
.LearnToRightClickModal.RollModal,
.RollModal.RollModal,
.FrogModal.RollModal {
  animation-name: fade-in;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}
.RollingModal.LearnToRightClickModal .UnitsSection,
.LootModal.LearnToRightClickModal .UnitsSection,
.LearnToRightClickModal.LearnToRightClickModal .UnitsSection,
.RollModal.LearnToRightClickModal .UnitsSection,
.FrogModal.LearnToRightClickModal .UnitsSection,
.RollingModal.RollModal .UnitsSection,
.LootModal.RollModal .UnitsSection,
.LearnToRightClickModal.RollModal .UnitsSection,
.RollModal.RollModal .UnitsSection,
.FrogModal.RollModal .UnitsSection {
  opacity: 0;
  animation-delay: 1s;
  animation-name: fade-in;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  position: relative;
  z-index: 10000;
}
.RollingModal.LearnToRightClickModal .Fill,
.LootModal.LearnToRightClickModal .Fill,
.LearnToRightClickModal.LearnToRightClickModal .Fill,
.RollModal.LearnToRightClickModal .Fill,
.FrogModal.LearnToRightClickModal .Fill,
.RollingModal.RollModal .Fill,
.LootModal.RollModal .Fill,
.LearnToRightClickModal.RollModal .Fill,
.RollModal.RollModal .Fill,
.FrogModal.RollModal .Fill {
  top: 0em;
  left: 0em;
  right: 0em;
  bottom: 0em;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: black;
  background: radial-gradient(circle 2em at center, transparent 1.9em, rgba(0, 0, 0, 0.8) 2em);
  transform: scale(10);
  animation-name: zoom-in;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 1s;
  animation-delay: 1s;
}
.RollingModal.LearnToRightClickModal.LearnToRightClickModal .Fill,
.LootModal.LearnToRightClickModal.LearnToRightClickModal .Fill,
.LearnToRightClickModal.LearnToRightClickModal.LearnToRightClickModal .Fill,
.RollModal.LearnToRightClickModal.LearnToRightClickModal .Fill,
.FrogModal.LearnToRightClickModal.LearnToRightClickModal .Fill,
.RollingModal.RollModal.LearnToRightClickModal .Fill,
.LootModal.RollModal.LearnToRightClickModal .Fill,
.LearnToRightClickModal.RollModal.LearnToRightClickModal .Fill,
.RollModal.RollModal.LearnToRightClickModal .Fill,
.FrogModal.RollModal.LearnToRightClickModal .Fill {
  background: radial-gradient(circle 1.5em at center, transparent 1.4em, rgba(0, 0, 0, 0.8) 1.5em);
}
.RollingModal.LearnToRightClickModal .Content,
.LootModal.LearnToRightClickModal .Content,
.LearnToRightClickModal.LearnToRightClickModal .Content,
.RollModal.LearnToRightClickModal .Content,
.FrogModal.LearnToRightClickModal .Content,
.RollingModal.RollModal .Content,
.LootModal.RollModal .Content,
.LearnToRightClickModal.RollModal .Content,
.RollModal.RollModal .Content,
.FrogModal.RollModal .Content {
  position: relative;
  z-index: 10;
}
.RollingModal.LearnToRightClickModal .Content .Header,
.LootModal.LearnToRightClickModal .Content .Header,
.LearnToRightClickModal.LearnToRightClickModal .Content .Header,
.RollModal.LearnToRightClickModal .Content .Header,
.FrogModal.LearnToRightClickModal .Content .Header,
.RollingModal.RollModal .Content .Header,
.LootModal.RollModal .Content .Header,
.LearnToRightClickModal.RollModal .Content .Header,
.RollModal.RollModal .Content .Header,
.FrogModal.RollModal .Content .Header {
  opacity: 0;
  animation-name: fade-in;
  animation-duration: 2s;
  animation-delay: 3s;
  animation-fill-mode: forwards;
  position: absolute;
  top: -4em;
  left: -8em;
  right: -8em;
  width: 10em;
  margin: auto;
}
.RollingModal.LearnToRightClickModal .Content .Footer,
.LootModal.LearnToRightClickModal .Content .Footer,
.LearnToRightClickModal.LearnToRightClickModal .Content .Footer,
.RollModal.LearnToRightClickModal .Content .Footer,
.FrogModal.LearnToRightClickModal .Content .Footer,
.RollingModal.RollModal .Content .Footer,
.LootModal.RollModal .Content .Footer,
.LearnToRightClickModal.RollModal .Content .Footer,
.RollModal.RollModal .Content .Footer,
.FrogModal.RollModal .Content .Footer {
  opacity: 0;
  animation-name: fade-in;
  animation-duration: 2s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  position: absolute;
  bottom: -2em;
  left: -8em;
  right: -8em;
  width: 10em;
  margin: auto;
  display: none;
}
.RollingModal.LearnToRightClickModal .Content .Footer[isVisible],
.LootModal.LearnToRightClickModal .Content .Footer[isVisible],
.LearnToRightClickModal.LearnToRightClickModal .Content .Footer[isVisible],
.RollModal.LearnToRightClickModal .Content .Footer[isVisible],
.FrogModal.LearnToRightClickModal .Content .Footer[isVisible],
.RollingModal.RollModal .Content .Footer[isVisible],
.LootModal.RollModal .Content .Footer[isVisible],
.LearnToRightClickModal.RollModal .Content .Footer[isVisible],
.RollModal.RollModal .Content .Footer[isVisible],
.FrogModal.RollModal .Content .Footer[isVisible] {
  display: block;
}
.RollingModal.RollModal .DiceCube,
.LootModal.RollModal .DiceCube,
.LearnToRightClickModal.RollModal .DiceCube,
.RollModal.RollModal .DiceCube,
.FrogModal.RollModal .DiceCube {
  perspective: 3em;
}
.RollingModal.RollModal .DiceCube:nth-child(1),
.LootModal.RollModal .DiceCube:nth-child(1),
.LearnToRightClickModal.RollModal .DiceCube:nth-child(1),
.RollModal.RollModal .DiceCube:nth-child(1),
.FrogModal.RollModal .DiceCube:nth-child(1) {
  margin-top: -0.25em;
}
.RollingModal.RollModal .DiceCube:nth-child(2),
.LootModal.RollModal .DiceCube:nth-child(2),
.LearnToRightClickModal.RollModal .DiceCube:nth-child(2),
.RollModal.RollModal .DiceCube:nth-child(2),
.FrogModal.RollModal .DiceCube:nth-child(2) {
  margin-left: 0.25em;
  margin-bottom: -0.25em;
}
.RollingModal.RollModal .DiceCube:nth-child(2) .Cube,
.LootModal.RollModal .DiceCube:nth-child(2) .Cube,
.LearnToRightClickModal.RollModal .DiceCube:nth-child(2) .Cube,
.RollModal.RollModal .DiceCube:nth-child(2) .Cube,
.FrogModal.RollModal .DiceCube:nth-child(2) .Cube {
  animation-delay: -1.2s;
}
.RollingModal.RollModal .DiceCube:nth-child(3),
.LootModal.RollModal .DiceCube:nth-child(3),
.LearnToRightClickModal.RollModal .DiceCube:nth-child(3),
.RollModal.RollModal .DiceCube:nth-child(3),
.FrogModal.RollModal .DiceCube:nth-child(3) {
  margin-left: 0.25em;
}
.RollingModal.RollModal .DiceCube:nth-child(3) .Cube,
.LootModal.RollModal .DiceCube:nth-child(3) .Cube,
.LearnToRightClickModal.RollModal .DiceCube:nth-child(3) .Cube,
.RollModal.RollModal .DiceCube:nth-child(3) .Cube,
.FrogModal.RollModal .DiceCube:nth-child(3) .Cube {
  animation-delay: -2.4s;
}
.RollingModal.RollModal .UnitsSection:hover .DiceCube,
.LootModal.RollModal .UnitsSection:hover .DiceCube,
.LearnToRightClickModal.RollModal .UnitsSection:hover .DiceCube,
.RollModal.RollModal .UnitsSection:hover .DiceCube,
.FrogModal.RollModal .UnitsSection:hover .DiceCube {
  animation-name: shake-the-dice;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 0.5s;
}
@keyframes shake-the-dice {
  0% {
    transform: translateX(-0.025em) translateY(0.025em);
  }
  10% {
    transform: translateX(0) translateY(0.025em);
  }
  20% {
    transform: translateX(0.025em) translateY(0em);
  }
  30% {
    transform: translateX(0) translateY(-0.025em);
  }
  40% {
    transform: translateX(0.025em) translateY(0.025em);
  }
  50% {
    transform: translateX(-0.025em) translateY(-0.025em);
  }
  60% {
    transform: translateX(-0.025em) translateY(0.025em);
  }
  70% {
    transform: translateX(0em) translateY(-0.025em);
  }
  80% {
    transform: translateX(0.025em) translateY(0em);
  }
  90% {
    transform: translateX(-0.025em) translateY(0.025em);
  }
  100% {
    transform: translateX(0em) translateY(0em);
  }
}
.RollingModal .UnitsSection,
.LootModal .UnitsSection,
.LearnToRightClickModal .UnitsSection,
.RollModal .UnitsSection,
.FrogModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.RollingModal .UnitsSection .Or,
.LootModal .UnitsSection .Or,
.LearnToRightClickModal .UnitsSection .Or,
.RollModal .UnitsSection .Or,
.FrogModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.RollingModal .UnitsSection .Unit,
.LootModal .UnitsSection .Unit,
.LearnToRightClickModal .UnitsSection .Unit,
.RollModal .UnitsSection .Unit,
.FrogModal .UnitsSection .Unit {
  width: 1em;
  font-size: 1.5em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.RollingModal .UnitsSection .Unit .Thumbnail,
.LootModal .UnitsSection .Unit .Thumbnail,
.LearnToRightClickModal .UnitsSection .Unit .Thumbnail,
.RollModal .UnitsSection .Unit .Thumbnail,
.FrogModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.RollingModal .UnitsSection .Unit .Thumbnail .UnitHealthBar,
.LootModal .UnitsSection .Unit .Thumbnail .UnitHealthBar,
.LearnToRightClickModal .UnitsSection .Unit .Thumbnail .UnitHealthBar,
.RollModal .UnitsSection .Unit .Thumbnail .UnitHealthBar,
.FrogModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.RollingModal .UnitsSection .Unit .DraftButton,
.LootModal .UnitsSection .Unit .DraftButton,
.LearnToRightClickModal .UnitsSection .Unit .DraftButton,
.RollModal .UnitsSection .Unit .DraftButton,
.FrogModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.RollingModal .UnitsSection .Unit .DraftButton span,
.LootModal .UnitsSection .Unit .DraftButton span,
.LearnToRightClickModal .UnitsSection .Unit .DraftButton span,
.RollModal .UnitsSection .Unit .DraftButton span,
.FrogModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.RollingModal .UnitsSection .Unit .DraftableDice .Number,
.LootModal .UnitsSection .Unit .DraftableDice .Number,
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .Number,
.RollModal .UnitsSection .Unit .DraftableDice .Number,
.FrogModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.125em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.RollingModal .UnitsSection .Unit .DraftableDice .Description,
.LootModal .UnitsSection .Unit .DraftableDice .Description,
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .Description,
.RollModal .UnitsSection .Unit .DraftableDice .Description,
.FrogModal .UnitsSection .Unit .DraftableDice .Description {
  font-size: 0.15em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.RollingModal .UnitsSection .Unit .DraftableDice .Description span,
.LootModal .UnitsSection .Unit .DraftableDice .Description span,
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .Description span,
.RollModal .UnitsSection .Unit .DraftableDice .Description span,
.FrogModal .UnitsSection .Unit .DraftableDice .Description span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.RollingModal .UnitsSection .Unit .DraftableDice .DiceLayout,
.LootModal .UnitsSection .Unit .DraftableDice .DiceLayout,
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .DiceLayout,
.RollModal .UnitsSection .Unit .DraftableDice .DiceLayout,
.FrogModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
}
.RollingModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice,
.LootModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice,
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice,
.RollModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice,
.FrogModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice {
  font-size: 1em;
}
.RollingModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace,
.LootModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace,
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace,
.RollModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace,
.FrogModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.RollingModal .UnitsSection .Unit .EquippedDice,
.LootModal .UnitsSection .Unit .EquippedDice,
.LearnToRightClickModal .UnitsSection .Unit .EquippedDice,
.RollModal .UnitsSection .Unit .EquippedDice,
.FrogModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.RollingModal .UnitsSection .Unit .EquippableDice,
.LootModal .UnitsSection .Unit .EquippableDice,
.LearnToRightClickModal .UnitsSection .Unit .EquippableDice,
.RollModal .UnitsSection .Unit .EquippableDice,
.FrogModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.RollingModal .UnitsSection .Unit .EquippableDice .Description,
.LootModal .UnitsSection .Unit .EquippableDice .Description,
.LearnToRightClickModal .UnitsSection .Unit .EquippableDice .Description,
.RollModal .UnitsSection .Unit .EquippableDice .Description,
.FrogModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.RollingModal .UnitsSection .Unit .Status,
.LootModal .UnitsSection .Unit .Status,
.LearnToRightClickModal .UnitsSection .Unit .Status,
.RollModal .UnitsSection .Unit .Status,
.FrogModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.RollingModal .UnitsSection .Unit[isLockedIn],
.LootModal .UnitsSection .Unit[isLockedIn],
.LearnToRightClickModal .UnitsSection .Unit[isLockedIn],
.RollModal .UnitsSection .Unit[isLockedIn],
.FrogModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.RollingModal .UnitsSection .Unit[isLockedIn] .Label,
.LootModal .UnitsSection .Unit[isLockedIn] .Label,
.LearnToRightClickModal .UnitsSection .Unit[isLockedIn] .Label,
.RollModal .UnitsSection .Unit[isLockedIn] .Label,
.FrogModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.RollingModal .UnitsSection .Unit[isLockedIn] .Status,
.LootModal .UnitsSection .Unit[isLockedIn] .Status,
.LearnToRightClickModal .UnitsSection .Unit[isLockedIn] .Status,
.RollModal .UnitsSection .Unit[isLockedIn] .Status,
.FrogModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.RollingModal .DoneSection,
.LootModal .DoneSection,
.LearnToRightClickModal .DoneSection,
.RollModal .DoneSection,
.FrogModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.RollingModal .DoneSection button,
.LootModal .DoneSection button,
.LearnToRightClickModal .DoneSection button,
.RollModal .DoneSection button,
.FrogModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.RollingModal .DoneSection button:not([isEnabled]),
.LootModal .DoneSection button:not([isEnabled]),
.LearnToRightClickModal .DoneSection button:not([isEnabled]),
.RollModal .DoneSection button:not([isEnabled]),
.FrogModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.RollingModal .DoneSection button:not(:last-child),
.LootModal .DoneSection button:not(:last-child),
.LearnToRightClickModal .DoneSection button:not(:last-child),
.RollModal .DoneSection button:not(:last-child),
.FrogModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes zoom-in {
  0% {
    transform: scale(10);
  }
  100% {
    transform: scale(1);
  }
}
